import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Alert,
  CircularProgress,
} from "@mui/material";
import {
  CheckCircle,
  Cancel,
} from "@mui/icons-material";

import { useUpdateMeetingAttendance } from "../../../store";

interface MeetingConfirmationInfoProps {
  userId: string,
  meetingId: string,
  joinCode: string,
  confirm: boolean | null
  setError: (error: string) => void
}


const MeetingConfirmationComponent: React.FC<MeetingConfirmationInfoProps> = ({
  userId,
  meetingId,
  joinCode,
  confirm,
  setError
}) => {

  const [submitting, setSubmitting] = useState(false);
  const [confirmed, setConfirmed] = useState<boolean | undefined>(undefined);

  const [triedConfirm, setTriedConfirm] = useState<boolean>(false)

  const { mutate: setAttendance } = useUpdateMeetingAttendance(
    (accept: boolean) => {
      setConfirmed(accept);

      setSubmitting(false)
    },
    (err) => {
      setError("Failed to update meeting attendance");
      console.error("Error updating meeting:", err);

      setSubmitting(false)
    },
  );

  const handleResponse = async (accept: boolean) => {
    if (!meetingId || !userId) {
      return;
    }

    setSubmitting(true);

    setAttendance({
      meetingId,
      userId,
      joinCode,
      accept,
    })
  }

  useEffect(() => {
    if (triedConfirm) {
      return
    }

    if (confirm == null) {
      return
    }

    setTriedConfirm(true)

    handleResponse(confirm)

  }, [confirm, triedConfirm, setTriedConfirm])

  return (
    <>

      {submitting &&
        <Stack spacing={2} alignItems="center" sx={{ mt: 2 }}>
          <CircularProgress size={40} />
          <Typography variant="body1">Loading...</Typography>
        </Stack>}

      {/* Response Status */}
      {confirmed !== null && !submitting && (
        <Stack spacing={2} alignItems="center" sx={{ mt: 2 }}> 
        <Alert
          severity={confirmed ? "success" : "error"}
          icon={confirmed ? <CheckCircle /> : <Cancel />}
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            border: confirmed ? "1px solid green" : "1px solid red",
          }}
        >
          <Typography
            variant="body1"
            fontWeight="medium"
            textAlign="center"
            sx={{ flex: 1 }}
          >
            {confirmed
              ? "You have confirmed your attendance"
              : "You have declined this meeting"}
          </Typography>
        </Alert>
        <Typography variant="body2" color="textSecondary">
           Thank you, you may now close this window.
        </Typography>
        </Stack>
      )}
    </>
  );
};

export default MeetingConfirmationComponent;
